import { render, staticRenderFns } from "./MiniCardCarousel.vue?vue&type=template&id=5d0223d4&"
import script from "./MiniCardCarousel.vue?vue&type=script&lang=js&"
export * from "./MiniCardCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports